import Cache from 'utils/cache';
import BoardingService from 'services/boardingService';

async function getDealers() {
  const dealers = Cache.getTemporary('boarding_dealers');
  if (dealers) {
    return dealers;
  }
  else {
    const newDealers = await BoardingService.API.getDealers();
    Cache.setTemporary('boarding_dealers', newDealers);
    return newDealers;
  }
}

async function getKeyDetails(dealer_id, key_id) {
  return await BoardingService.API.getKeyDetails(dealer_id, key_id);
}

async function getUserDetails(dealer_id, email) {
  return await BoardingService.API.getUserDetails(dealer_id, email);
}

async function insertOrder(order) {
  return await BoardingService.API.insertOrder(order);
}




const BoardingHelper = {
  getDealers,
  getKeyDetails,
  getUserDetails,
  insertOrder,

  enums: {
    steps: {
      StepsMenu: 1,
      DealerSelection: 2,
      StoreKeyEntry: 3,
      StoreSearch: 4,
      StoreDetails: 5,
      StoreError: 6,
      StoreErrorReporting: 7,
      UserEmailEntry: 8,
      UserSearch: 9,
      UserDetails: 10,
      UserFound: 11,
      UserError: 12,
      UserErrorReporting: 13,
    },
  },
};

export default BoardingHelper;